export const SENSITIVE_DATA_CLASS = 'amp-mask';
export default SENSITIVE_DATA_CLASS;
